import styled from "styled-components";

export const Container = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #1e958c 0%, #0b4f6c 40%, #f5f7fb 100%);
`;

export const ContentArea = styled.div`
  width: 100%;
  max-width: 1040px;
  margin: 16px auto 24px;
  padding: 20px 16px 28px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.16);
  display: flex;
  flex-direction: column;
  gap: 18px;
  backdrop-filter: blur(8px);
`;

export const TitlePage = styled.span`
  text-align: center;
  font-weight: 700;
  font-size: 22px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #1e958c;
  margin: 4px auto 8px;
`;

export const StudentsList = styled.div`
  width: 100%;
  max-height: 600px;
  overflow-y: auto;
  padding: 16px;
  background-color: #f5f5f5;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  
  @media only screen and (max-width: 820px) {
    max-height: 500px;
  }
`;

export const SelectionArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  
  @media only screen and (max-width: 500px) {
    flex-direction: column;
    width: 100%;
  }
`;
